import React from 'react';
import {Link} from "react-router-dom";

// Style sheets
import Style from './Header.module.scss';

export function Header(props){
    const currentPressed = props.currentPressed;
    const page = props.currentPage;
    const darkMode = props.darkMode;

    return(
        <div className={Style.Header}>
            <Link aria-label={page === "/" ? "Go to History" : "Go to Calculator"} to={page === "/" ? "/history" : "/"} className={Style.Button} onClick={props.onClickHandleClear}><i className={page === "/" ? "fas fa-history" : "fas fa-times-circle"}></i></Link>
            <h6 className={page === "/history" ? Style.HistoryHeader : Style.Hidden}>History</h6>
            <h6 className={page === "/" ? Style.Text : Style.Hidden}>Characters Count: {String(currentPressed).length > 12 ? "Over" : String(currentPressed).length}</h6>
            <button aria-label={darkMode === true ? "Toggle Light Mode" : "Toggle Dark Mode"} onClick={props.onClickDarkLightMode} className={Style.Button}><i className={darkMode === true ? "fas fa-sun" : "fas fa-moon" }></i></button>
        </div>
    );
}